import { useEffect, useState } from "react";

const WHATSAPP_NUMBER = "9163645572729";
const DEFAULT_MESSAGE =
  "Hi, I'm interested in your corporate gifting solutions. Could you share more details?";

const WhatsappChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState(DEFAULT_MESSAGE);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    if (isOpen) document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [isOpen]);

  const handleSend = (e) => {
    e.preventDefault();
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
    setIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        aria-label="Chat with us on WhatsApp"
        className="whatsapp-fab"
        onClick={() => setIsOpen(true)}
      >
        <i className="fa fa-whatsapp"></i>
      </button>

      <div
        className={`whatsapp-overlay${isOpen ? " whatsapp-overlay--open" : ""}`}
        onClick={() => setIsOpen(false)}
      />

      <div
        className={`whatsapp-sidebar${isOpen ? " whatsapp-sidebar--open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="WhatsApp chat"
      >
        <div className="whatsapp-sidebar-header">
          <div className="whatsapp-sidebar-title">
            <i className="fa fa-whatsapp"></i>
            <span>Chat with us</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            className="whatsapp-sidebar-close"
            onClick={() => setIsOpen(false)}
          >
            <i className="fa fa-times"></i>
          </button>
        </div>

        <div className="whatsapp-sidebar-body">
          <p>Send us a message on WhatsApp and our team will get back to you shortly.</p>
          <form onSubmit={handleSend}>
            <textarea
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button type="submit" className="whatsapp-send-btn">
              <i className="fa fa-whatsapp"></i> Send on WhatsApp
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default WhatsappChat;
